export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12795.b147a665.jpg";